import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/SearchResults2.css";

export default function SearchResults({ results, query }) {
  const navigate = useNavigate();

  if (!results || results.length === 0) {
    return (
      <div className="search-results">
        <p className="no-results">No results found for "{query}"</p>
      </div>
    );
  }

  const handleClick = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <div className="search-results">
      {results.map((item, index) => (
        <div
          key={index}
          className="search-result-item"
          onClick={() => handleClick(item._id)}
          style={{ cursor: "pointer" }}
        >
          <img
            src={item.image || "/placeholder.png"}
            alt={item.name}
            className="result-image"
          />
          <div className="result-info">
            <h4 className="result-name">{item.name}</h4>
            <p className="result-price">₹{item.price}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
